import { NavigationGuard } from 'vue-router';

import { loginRoute } from '@/pages/login/route';
import store from '@/store';

/**
 * Refresh token before navigating to the next route. If an error is thrown, it
 * is likely because the token is already expired. If so, redirect back to the
 * login page.
 *
 * Usage (in router.ts):
 *
 * export default new Router({
 *   routes: [
 *     {
 *       ...
 *       beforeEnter: refreshToken,     <--- add to `beforeEnter`
 *     },
 *     ...
 *   ],
 * });
 */
export const refreshToken: NavigationGuard = (to, from, next) => {
  store.dispatch('user/refreshToken')
    .then(() => {
      next();
    })
    .catch(() => {
      next({
        name: loginRoute.name,
        query: { next: to.path },  // go to after login
      });
    });
};
